module.exports = __webpack_public_path__ + "assets/img/ru-3d75441c.png";